//calanderList/actionCreators.js

import actionTypes from './actionTypes';

//public actions
const requestGameDateData = () => ({
    type: actionTypes.REQUEST_GAME_DATE_DATA
});

const gameDateDataResponse = (success, data, errors) => ({
    type: actionTypes.GAME_DATE_DATA_RESPONSE,
    payload: {
        success: success,
        gameDateData: data,
        errors: errors
    }
});

const setNumberOfEventsByDate = (events) => ({
    type: actionTypes.SET_EVENTS_BY_DATE,
    eventsByDate: events
});

export default {
    requestGameDateData,
    gameDateDataResponse,
    setNumberOfEventsByDate
}